import TruckingCompanyCard from './TruckingCompanyCard';

export default TruckingCompanyCard;
